import {
  Backdrop,
  Box,
  Button,
  Grid,
  Link as MuiLink,
  ListItemIcon,
  makeStyles,
  Menu,
  MenuItem,
  Switch,
  Theme,
  TextField,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditIcon from "@material-ui/icons/Edit";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Tooltip } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as vehicleLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns } from "./components/columns";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import {
  getNodVehicleDetailsByIdAction,
  markVehicleEntryAsReview,
} from "src/app-redux/vehicle/actions/vehicleActions";
import Drawer from "./components/Drawer";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { PrintSharp, CancelRounded, MoreVert, Warning } from "@material-ui/icons";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import { object, string } from "yup";
import { getActiveApprovalUsers } from "src/app-redux/configuration/actions/configurationActions";
import { selectAllActiveApprovalUserList } from "src/app-redux/configuration/configurationSlice";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  customButton: {
    "& .MuiButton-iconSizeSmall": {
      marginRight: "0",
    },
    "& .MuiBox-root": {
      marginRight: "8px",
    },
  },
  menu: {
    left: "0",
    "& .MuiPopover-paper": {
      width: "max-content",
    },
  },
}));

interface Props {}

export function ListVehicles({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [vehicleConfiguration, setvehicleConfiguration] = React.useState<any>([]);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = VehicleManagementRoute.title;
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const pageHeading = "List of Vehicles";
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const receiptLoader: any = useAppSelector(gateEntryLoader);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const history = useHistory();
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);
  const [listAction, setListAction] = useState<any>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickActionBtn = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseActionBtn = () => {
    setAnchorEl(null);
  };

  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const dispatch = useDispatch();

  const [isOpenEditDailog, setIsOpenEditDailog] = useState<boolean>(false);
  const [isOpenConfirmationDailog, setIsOpenConfirmationDailog] = useState<boolean>(false);
  const [invalidVehicleId, setInvalidVehicleId] = useState<number>(0);
  const [, setRemarks] = useState("");
  const allApprovalUserList = useAppSelector(selectAllActiveApprovalUserList);

  const handleCloseConfirmationDialog = () => {
    formik.resetForm();
    formik.setValues({
      ...formik.initialValues,
      InProgressVehiclesDataOnly: formik.values.InProgressVehiclesDataOnly,
      filterBy: formik.values.filterBy,
      startDate: formik.values.startDate,
      endDate: formik.values.endDate,
    });
    setIsOpenConfirmationDailog(false);
  };

  const handleConfirmationDialog = async () => {
    formik.submitForm();
  };
  const handleSubmitEditDialog = async () => {
    formik2.submitForm();
  };
  const handleCloseEditDialog = () => {
    setIsOpenEditDailog(false);
    formik2.resetForm();
  };
  const updateVehicleDetains = (data: any) => {
    formik2.setFieldValue("vehicleNumber", data?.vehicleNumber);
    formik2.setFieldValue("vehicleId", data?.vehicleId);
    formik2.setFieldValue("vehicleTypeId", data?.vehicleTypeId);
    formik2.setFieldValue("driverName", data?.driverName);
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return row.original.isDeleted ? (
                  <>
                    <Tooltip
                      title={"This entry has been marked as invalid"}
                      placement="bottom-start"
                    >
                      <span className={classes.customButton}>
                        <NewCommonButton
                          style={{ minWidth: "30px", padding: "4px" }}
                          icon={<Warning />}
                        >
                          {/* Marked as Wrong Entry */}
                        </NewCommonButton>
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <React.Fragment>
                    <Box>
                      <Tooltip title="More">
                        <Button
                          onClick={(e) => {
                            updateVehicleDetains(row.original);

                            row.original?.notes != null || row.original?.notes != undefined
                              ? setRemarks(row.original?.notes)
                              : setRemarks("");
                            setListAction(row.original);
                            handleClickActionBtn(e);
                          }}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          style={{ minWidth: "30px", padding: "4px" }}
                        >
                          <MoreVert />
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "vehicleNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getNodVehicleDetailsByIdAction(row.original.vehicleId));
                        dispatch(setSelectedVehicleId(row.original.vehicleId));
                        setisDrawerOpen(true);
                      }}
                    >
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);
  // Removed unused variable 'dppr'

  const formik = useFormik<any>({
    initialValues: {
      InProgressVehiclesDataOnly: true,
      filterBy: "today",
      vehicleStatusId: 10,
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      remarks: "",
      approvalUserId: "",
      userName: "",
      regNumber: "",
    },
    validationSchema: object({
      remarks: string()
        .required("This field is required")
        .max(3000, "Maximum 3000 characters are allowed"),
      approvalUserId: string().required("This field is required"),
    }),
    onSubmit: async (values) => {
      const params = {
        gatePassId: invalidVehicleId,
        invalidRemarks: values?.remarks,
        approvalUserId: values.approvalUserId,
        userName: values.userName,
        regNumber: values.regNumber,
      };
      handleCloseConfirmationDialog();
      if (invalidVehicleId) {
        await dispatch(markVehicleEntryAsReview(params));

        formik.setFieldValue("remarks", "");
        formik.setFieldValue("filterBy", "today");
        handleSearch();
      }
    },
  });

  const formik2 = useFormik<any>({
    initialValues: {
      vehicleId: "",
      vehicleNumber: "",
      driverName: "",
      vehicleTypeId: "",
    },
    validationSchema: object({
      vehicleNumber: string().required("This field is required"),
      driverName: string().required("This field is required"),
      vehicleTypeId: string().required("This field is required"),
    }),
    onSubmit: async (values) => {
      handleCloseEditDialog();
      setLoader(true);
      await fetchWrapper.post("update-vehicle", values);
      handleSearch();
    },
  });

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = formik.values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(searchData("/get-all-vehicles", JSON.stringify(body)));
      if (results) {
        const transformedData = results.map((data: any) => {
          return {
            ...data,
            id: data.gatePassId,
            yardSlotInfo:
              data.yardName && data.rowName && data.slotNumber
                ? `${data.yardName}, Row ${data.rowName}, Slot ${data.slotNumber}`
                : "",
          };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const [resetHandler, setResetHandler] = useState(false);
  const resetSearch = () => {
    formik.setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };

  const getVehicleConfiguration = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        setvehicleConfiguration(results.value);
        return setLoader(false);
      }
    } catch (error: any) {
      setLoader(false);
    }
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    getVehicleConfiguration();
    setResetHandler(false);
    dispatch(getActiveApprovalUsers());
  }, [resetHandler]);
  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  const [isOpenGateInPrintDailog, setIsOpenGateInPrintDailog] = useState<boolean>(false);
  const [isOpenGateOutPrintDailog, setIsOpenGateOutPrintDailog] = useState<boolean>(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const printReceiptGateIn = async (isDuplicate: string) => {
    setIsOpenGateInPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-entry-slip-by-vehicle-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  const printReceiptGateOut = async (isDuplicate: string) => {
    setIsOpenGateOutPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-out-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&isNod=true&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        Vehicle: data?.vehicleNumber,
        "VIR No.": data?.virNumber || "",
        Driver: data?.driverName,
        Type: data?.vehicleType,
        Status: data?.vehicleStatus,
        Consignment: data?.consignmentType,
        "GD #": data?.gdNumber,
        Cargo: data?.cargoTypeName,
        Entry: data.gateEntryDate ? moment(data.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Checkout: data.gateOutDate ? moment(data.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : "",
      };
    });
    return exportedRecords;
  };

  function handleValueChange(e: any) {
    formik2.handleChange(e);
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      {/* Dialog for Gate-In */}
      <DuplicateReceiptDialog
        isOpen={isOpenGateInPrintDailog}
        handleOriginal={() => {
          printReceiptGateIn("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceiptGateIn("1");
        }}
        onClose={() => {
          setIsOpenGateInPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      {/* Dialog for gate out */}
      <DuplicateReceiptDialog
        isOpen={isOpenGateOutPrintDailog}
        handleOriginal={() => {
          printReceiptGateOut("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceiptGateOut("1");
        }}
        onClose={() => {
          setIsOpenGateOutPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        className={classes.menu}
        onClose={handleCloseActionBtn}
        onClick={handleCloseActionBtn}
      >
        {/* Edit */}
        {/* <Tooltip
          title={listAction?.editDisable ? "Old gate entry cannot be edited" : "Edit"}
          followCursor
        > */}
        <MenuItem
          onClick={() => {
            setIsOpenEditDailog(true);
            handleCloseActionBtn();
          }}
          disabled={listAction?.vehicleStatus == "Checked-out"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#1976d2" }}>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>
        {/* </Tooltip> */}
        {/* Checkout */}
        <MenuItem
          onClick={() => {
            history.push(
              localStorage.getItem("allowedRoutes")?.includes("/nod/gate-entry/gate-out")
                ? `/nod/gate-entry/gate-out-details/${listAction?.vehicleId}`
                : localStorage.getItem("defaultRoute") || ""
            );
            handleCloseActionBtn();
          }}
          // disabled={!listAction?.vehicleInProgress}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <RemoveCircleIcon fontSize="small" />
          </ListItemIcon>
          Checkout
        </MenuItem>
        {/* Print Gate-in receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.vehicleId);
            setIsOpenGateInPrintDailog(true);
            handleCloseActionBtn();
          }}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Gate-in receipt
        </MenuItem>
        {/* Print Gate-out receipt */}
        <MenuItem
          onClick={() => {
            setSelectedRecordId(listAction?.id);
            setIsOpenGateOutPrintDailog(true);
            handleCloseActionBtn();
          }}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#72CA00" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Gate-out receipt
        </MenuItem>
        {/* Mark as invalid */}
        <MenuItem
          onClick={() => {
            setIsOpenConfirmationDailog(true);
            setInvalidVehicleId(listAction?.id);
            formik.setFieldValue("regNumber", listAction.vehicleNumber);

            handleCloseActionBtn();
          }}
          disabled={!listAction?.vehicleInProgress || listAction?.vehicleStatus == "Pending Review"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <CancelRounded fontSize="small" />
          </ListItemIcon>
          Mark as invalid
        </MenuItem>
      </Menu>

      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={vehicleRecord}
            columns={displayColumns}
            loader={loader || loader2}
            defaultPerPageRecord={15}
            height={550}
            deletedRow={true}
            isExport={isExport}
            exportHandler={exportHandler}
            filename={`List_of_vehicle_${Date.now()}`}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={3} lg={2}>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                helperText={formik.touched.filterBy && formik.errors.filterBy}
                label="Filter by"
                placeholder="Filter by"
                name="filterBy"
                disableClearable={true}
                optionsType={filteryByArr}
                getOptionLabel={(option: any) => option.label || null}
                onChange={(row: any) => {
                  row ? formik.setValues({ ...formik.values, filterBy: row.value || "" }) : "";
                  if (row === null) {
                    formik.setFieldValue("filterBy", null);
                  }
                  filterByAction(row);
                }}
                value={
                  filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                }
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"Start Date"}
                name={"startDate"}
                datePickerRef={startDatePickerRef}
                value={formik.values.startDate}
                onChange={(e: any) => {
                  formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  formik.setFieldValue("endDate", "");
                }}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"End Date"}
                name={"endDate"}
                datePickerRef={endDatePickerRef}
                value={formik.values.endDate}
                onChange={(e: any) => {
                  formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                }}
                minDate={formik.values.startDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                    onChange={formik.handleChange}
                    name="InProgressVehiclesDataOnly"
                    color="primary"
                  />
                }
                label="In Progress Vehicles"
              />
            </Grid>

            <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
              <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
      <TransitionDialog
        isOpen={isOpenConfirmationDailog}
        handleClose={() => handleCloseConfirmationDialog()}
        heading={"Confirmation"}
        handleConfirm={() => handleConfirmationDialog()}
      >
        Are you sure you want to mark this vehicle as invalid?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formik.values.remarks}
            onChange={(e) => formik.setFieldValue("remarks", e.target.value)}
            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
            helperText={formik.touched.remarks && formik.errors.remarks}
          />
        </Box>
        <Box>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            disabled={false}
            label="Assign to"
            name="userId"
            placeholder="Select User"
            disableClearable={true}
            optionsType={allApprovalUserList?.filter(
              (list: any) => list?.userId != Number(localStorage?.getItem("nodUserId"))
            )}
            getOptionLabel={(option) => `${option.userName}`}
            required
            value={
              allApprovalUserList.find((st: any) => st.userId === formik.values.approvalUserId) ||
              null
            }
            onChange={(option: any) => {
              formik.setFieldValue("approvalUserId", option.userId);
              formik.setFieldValue("userName", option.userName);
            }}
            error={formik.touched.approvalUserId && Boolean(formik.errors.approvalUserId)}
            helperText={formik.touched.approvalUserId && formik.errors.approvalUserId}
          />
        </Box>
      </TransitionDialog>
      <TransitionDialog
        isOpen={isOpenEditDailog}
        handleClose={() => handleCloseEditDialog()}
        heading={"Vehicle Update"}
        handleConfirm={() => handleSubmitEditDialog()}
      >
        <Box style={{ marginTop: "10px", marginBottom: "10px", width: "500px" }}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                size="small"
                fullWidth
                required
                className="customTextField"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Vehicle Number"
                name="vehicleNumber"
                id="vehicleNumber"
                placeholder="Enter Vehicle Number"
                value={formik2.values.vehicleNumber?.toUpperCase()}
                onChange={(e: any) => {
                  if (/[^A-Za-z0-9\d]/.test(e.nativeEvent.data)) e.preventDefault();
                  else handleValueChange(e);
                }}
                onPaste={(e: any) => {
                  if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                }}
                error={formik2.touched.vehicleNumber && Boolean(formik2.errors.vehicleNumber)}
                helperText={formik2.touched.vehicleNumber && formik2.errors.vehicleNumber}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik2.touched.vehicleTypeId && Boolean(formik2.errors.vehicleTypeId)}
                helperText={formik2.touched.vehicleTypeId && formik2.errors.vehicleTypeId}
                label="Vehicle Type"
                name="vehicleTypeId"
                optionsType={vehicleConfiguration?.vehicleTypeData}
                placeholder="Select Vehicle Type"
                required
                getOptionLabel={(option: any) => option.name || ""}
                value={
                  vehicleConfiguration?.vehicleTypeData?.find(
                    (st: any) => st.id === formik2.values.vehicleTypeId
                  ) || null
                }
                onChange={(option: any) => {
                  if (option && option.id !== 0) {
                    formik2.setFieldValue("vehicleTypeId", option.id);
                    handleValueChange({ target: { value: option.id } });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                size="small"
                fullWidth
                className="customTextField"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Driver Name"
                name="driverName"
                id="driverName"
                placeholder="Enter Driver Name"
                value={formik2.values.driverName}
                onChange={handleValueChange}
                onPaste={(e: any) => {
                  if (/[^A-Za-z ]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                }}
                onKeyDownCapture={(e: any) => {
                  if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                }}
                error={formik2.touched.driverName && Boolean(formik2.errors.driverName)}
                helperText={formik2.touched.driverName && formik2.errors.driverName}
              />
            </Grid>
          </Grid>
        </Box>
      </TransitionDialog>
    </>
  );
}
